import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { MembershipPerks } from "@/components/MembershipPerks";
import { WhatsComingSection } from "@/components/WhatsComingSection";
import { InvestmentReturns } from "@/components/InvestmentReturns";
import { HowItWorks } from "@/components/HowItWorks";
import { FAQ } from "@/components/FAQ";
import { TrackSection } from "@/Pages/Sections";
import WaitlistForm from "@/components/WaitlistForm";
import { Footer } from "@/components/Footer";
import EarlyWaitlist from "@/components/EarlyWaitlist";
import {LimitedOffers} from "@/components/LimitedOffers";

const Index = () => {
  return (
    <div className="min-h-screen bg-[var(--dark-bg)] from-gray-50 to-gray-100 flex flex-col">
      <Header />

      {/* Main content */}
      <div className="">
        <TrackSection id="hero" minHeight="20vh">
          <Hero />
        </TrackSection>

        {/* <TrackSection id="membership_perks"
         minHeight="0vh"
          className="p-4"
          // style={{height:500}}
          >
          <MembershipPerks />
        </TrackSection> */}

        {/* <div id="membership_perks"  className=" p-4"> */}
        <TrackSection id="membership_perks" className=" p-4 ">

          <MembershipPerks />

        </TrackSection>

        <TrackSection id="Limited_Offers" className="flex-1 p-4 md:p-12" 
        minHeight="20vh"
        >
          <LimitedOffers />
        </TrackSection>


        <TrackSection className="flex-1 p-4 md:p-12  md:scroll-mt-24"
          id="whats_coming"
          minHeight="20vh"
        >
          <WhatsComingSection />
        </TrackSection>

        <TrackSection id="investment_returns" minHeight="20vh" className="flex-1 p-4 md:p-10">
          <InvestmentReturns />
        </TrackSection>

        <TrackSection
          id="how_it_works"
          minHeight="20vh"
          className="flex-1 p-4 md:p-12  md:scroll-mt-24"
        >
          <HowItWorks />
        </TrackSection>

        <TrackSection
          id="faq"
          minHeight="20vh"
          className="flex-1 p-4 md:p-16  md:scroll-mt-24"
        >
          <FAQ />
        </TrackSection>

        <TrackSection id="EarlyWaitlist" className="flex-1 p-4 md:p-16  md:scroll-mt-24" minHeight="60vh">
          <EarlyWaitlist />
        </TrackSection>

      </div>

      {/* Footer fixed at bottom */}
      <TrackSection id="Footer" className="flex-1 p-4 md:p-16  md:scroll-mt-24" minHeight="20vh"
        style={{
          borderTop: '1px solid transparent',
          borderImageSource: 'radial-gradient(50% 316.89% at 50% 0.02%, #DBAD71 0%, #111111 100%)',
          borderImageSlice: 1
        }}>
        <Footer />
      </TrackSection>
    </div>
  );
};

export default Index;
